import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { useAppContext } from '~/contexts';
import { usePlaylist } from '../context';
import { Actions } from './actions';
import { PlaylistToolbar } from './toolbar';

export interface LayoutProps {
  children: ReactNode;
  noPadding?: boolean;
}

export const Layout = ({ children, noPadding = false }: LayoutProps) => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const { playlist } = usePlaylist();
  const location = useLocation();

  return (
    <>
      <PlaylistToolbar actions={<Actions playlist={playlist} />} />
      <nav>
        <RouterTabs
          tabs={[
            { label: t('pages.playlists.detail.tabs.design'), to: '../design' },
            { label: t('common.labels.preview'), to: '../preview' },
            { label: t('common.labels.settings'), to: '../settings' },
            { label: t('pages.playlists.detail.tabs.usage'), to: '../usage' },
            ...(currentNetwork.canManage.value
              ? [
                  {
                    label: t('common.tabs.audit_logs'),
                    to: { pathname: '../audit-logs', search: location.search },
                  },
                ]
              : []),
          ]}
          variant="scrollable"
        />
      </nav>
      <PageContainer padding={!noPadding}>{children}</PageContainer>
    </>
  );
};
